<template>
  <div class="calcu-body buyness-calcu">
    <van-form class="form-bg">
      <!-- 计算方式 -->
      <van-field name="radio" label="计算方式" class="cal-method">
        <template #input>
          <van-radio-group
            v-model="formData.methodType"
            direction="horizontal"
            @change="calcuMethodChange"
          >
            <div class="radioDiv">
              <van-radio
                name="2"
                :class="
                  Number(formData.methodType) === 2 ? 'active' : 'inactive'
                "
              >
                <div class="radio-text">按贷款总额</div></van-radio
              >
              <van-radio
                name="1"
                :class="
                  Number(formData.methodType) === 1 ? 'active' : 'inactive'
                "
              >
                <div class="radio-text">按房屋总价</div>
              </van-radio>
            </div>
          </van-radio-group>
        </template>
      </van-field>

      <!-- 房屋总价 -->
      <van-field
        v-model="formData.houseTotal"
        type="number"
        name="房屋总价"
        label="房屋总价"
        placeholder="请输入房屋总价"
        autocomplete="off"
        v-if="formData.calcuMethod === '按房屋总价'"
        @click-input="houseTotalShow"
        readonly
      >
        <template #input>
          <div @click="houseTotalShow" class="input-container">
            <span>{{ formData.houseTotal }}</span>
            <div
              :style="houseKeyboardShow ? 'opacity:1' : 'opacity:0'"
              class="cursor"
            ></div>
          </div>
        </template>
        <template #right-icon>
          <span class="suffix">万</span>
        </template>
      </van-field>
      <!-- 房屋总价的数字键盘 -->
      <van-number-keyboard
        :show="houseKeyboardShow"
        v-model="formData.houseTotal"
        theme="custom"
        extra-key="."
        close-button-text="完成"
        @close="houseKeyboardClose"
        @blur="houseKeyboardClose"
        style="z-index: 3000"
      />

      <!-- 首付比例 -->
      <van-field
        v-model="formData.downPayment"
        name="radio"
        label="首付比例"
        v-if="formData.calcuMethod === '按房屋总价'"
        @click-left-icon="handleownPayment"
        @click-input="shoufuKeyboardShow = true"
        readonly
      >
        <template #input>
          <div @click="shoufuKeyboardShow = true" class="input-container">
            <span>{{ formData.downPayment }}</span>
            <div
              :style="shoufuKeyboardShow ? 'opacity:1' : 'opacity:0'"
              class="cursor"
            ></div>
          </div>
        </template>
        <template #right-icon>
          <span class="suffix"> %</span>
        </template>
      </van-field>
      <van-number-keyboard
        :show="shoufuKeyboardShow"
        v-model="formData.downPayment"
        theme="custom"
        extra-key="."
        close-button-text="完成"
        @close="shoufuKeyboardClose"
        @blur="shoufuKeyboardClose"
        style="z-index: 3000"
      />

      <!-- 贷款总额 -->
      <van-field
        type="number"
        v-model="formData.total"
        name="贷款总额"
        label="贷款总额"
        placeholder="请输入贷款总额"
        autocomplete="off"
        @click="totalShow"
        readonly
      >
        <template #input>
          <div @click="totalShow" class="input-container">
            <span>{{ formData.total }}</span>
            <div
              :style="totalkeyboardShow ? 'opacity:1' : 'opacity:0'"
              class="cursor"
            ></div>
          </div>
        </template>
        <template #right-icon>
          <span class="suffix">万</span>
        </template>
      </van-field>
      <!-- 贷款总额-数字键盘 -->
      <van-number-keyboard
        :show="totalkeyboardShow"
        v-model="formData.total"
        theme="custom"
        extra-key="."
        close-button-text="完成"
        @close="totalKeyboardClose(true)"
        @blur="totalKeyboardClose(false)"
        style="z-index: 3000"
      />

      <img
        style="margin-left: 12px; width: 342px; margin-top: 20px"
        src="https://static-official.5i5j.com/offical/cdn/e0436efb79e6ea18d85b4fae768a3e0a_1732255306161.png"
      />

      <!-- 公积金总额 -->
      <van-field
        v-model="formData.acctotal"
        type="number"
        name="公积金总额"
        label="公积金总额"
        placeholder="请输入公积金总额"
        autocomplete="off"
        @click="acctotalShow"
        readonly
      >
        <template #input>
          <div @click="acctotalShow" class="input-container">
            <span>{{ formData.acctotal }}</span>
            <div
              :style="acctotalKeyboardShow ? 'opacity:1' : 'opacity:0'"
              class="cursor"
            ></div>
          </div>
        </template>
        <template #right-icon>
          <span class="suffix">万</span>
        </template>
      </van-field>
      <!-- 公积金总额-数字键盘 -->
      <van-number-keyboard
        :show="acctotalKeyboardShow"
        v-model="formData.acctotal"
        theme="custom"
        extra-key="."
        close-button-text="完成"
        @close="acctotalKeyboardClose"
        @blur="acctotalKeyboardClose"
        style="z-index: 3000"
      />

      <!-- 贷款年限 -->
      <van-field
        readonly
        clickable
        v-model="formData.accLoanTerm"
        label="公积金年限"
        placeholder="点击选择公积金年限"
        @focus="showAccLoanTermPicker = true"
        @click-right-icon="showAccLoanTermPicker = true"
      >
        <template #right-icon>
          <img
            src="https://static-official.5i5j.com/offical/cdn/f92d18faa3f0d02eec919e78f354c308_1732253601301.png"
            alt=""
            width="15"
            height="15"
          />
        </template>
      </van-field>
      <keep-alive>
        <!-- <Picker
          title="贷款年限"
          :pickList="loanTermList"
          typeKey="accloanTerm"
          v-if="showAccLoanTermPicker"
          @pickerHandle="pickerHandle"
          @pickerClose="pickerClose"
        >
          <template #footer>
            <div class="picker-footer">
              <span>自定义输入</span>
              <input
                type="number"
                placeholder="请输入贷款年限"
                v-model="formData.customAccTerm"
                @input="inputReg"
              />
              <button class="customer-btn" @click="handleAccCustomTerm">
                确定
              </button>
            </div>
          </template>
        </Picker> -->
        <van-popup v-model="showAccLoanTermPicker" round position="bottom">
          <van-picker
            title="公积金年限"
            show-toolbar
            :default-index="
              fundLoanTermList.findIndex(
                (item) => formData.accLoanTerm === item
              ) || 0
            "
            :columns="fundLoanTermList"
            @confirm="onAccLoanTermCancel"
            @cancel="showAccLoanTermPicker = false"
        /></van-popup>
      </keep-alive>

      <!-- 公积金利率 -->
      <van-field
        readonly
        clickable
        v-model="formData.accrate"
        label="公积金利率"
        placeholder="点击选择利率方式"
        @focus="showAccRatePicker = true"
        @click-left-icon="handleRateHelp"
        @click-right-icon="showAccRatePicker = true"
        class="left-195"
      >
        <template #right-icon>
          <span v-if="spanShows" class="suffix"> % </span>
          <img
            src="https://static-official.5i5j.com/offical/cdn/f92d18faa3f0d02eec919e78f354c308_1732253601301.png"
            alt=""
            width="15"
            height="15"
          />
        </template>
      </van-field>
      <keep-alive>
        <NewPicker
          title="公积金利率"
          :pickList="accRateList"
          typeKey="accRate"
          v-if="showAccRatePicker"
          @pickerHandle="pickerHandle"
          @pickerClose="pickerClose"
          @clickPicker="handleAccCustomRate"
        >
          <template #footer>
            <div class="picker-footer">
              <span>自定义输入</span>
              <input
                type="text"
                placeholder="请输入公积金利率"
                v-model="formData.accCustomRate"
              />%
              <!-- <button class="customer-btn" @click="handleAccCustomRate">
                确定
              </button> -->
            </div>
          </template>
        </NewPicker>
      </keep-alive>
      <img
        style="margin-left: 12px; width: 342px; margin-top: 20px"
        src="https://static-official.5i5j.com/offical/cdn/e0436efb79e6ea18d85b4fae768a3e0a_1732255306161.png"
      />

      <!-- 商业金额 -->
      <van-field
        v-model="formData.businessLoan"
        type="number"
        name="商贷金额"
        label="商贷金额"
        placeholder="请输入商贷金额"
        autocomplete="off"
        @click="businessLoanKeyboardShow = true"
        @blur="businessLoanKeyboardShow = false"
        @focus="businessLoanFocus"
      >
        <template #input>
          <div @click="businessLoanFocus" class="input-container">
            <span>{{ formData.businessLoan }}</span>
            <div
              :style="businessLoanKeyboardShow ? 'opacity:1' : 'opacity:0'"
              class="cursor"
            ></div>
          </div>
        </template>
        <template #right-icon>
          <span class="suffix">万</span>
        </template>
      </van-field>
      <!-- 商业金额-数字键盘 -->
      <van-number-keyboard
        :show="businessLoanKeyboardShow"
        v-model="formData.businessLoan"
        theme="custom"
        extra-key="."
        close-button-text="完成"
        @close="businessLoanKeyboardClose"
        @blur="businessLoanKeyboardClose"
        style="z-index: 3000"
      />

      <!-- 商业贷款-贷款年限 -->
      <van-field
        readonly
        clickable
        v-model="formData.loanTerm"
        label="商贷年限"
        placeholder="点击选择商贷年限"
        @focus="showLoanTermPicker = true"
        @click-right-icon="showLoanTermPicker = true"
      >
        <template #right-icon>
          <img
            src="https://static-official.5i5j.com/offical/cdn/f92d18faa3f0d02eec919e78f354c308_1732253601301.png"
            alt=""
            width="15"
            height="15"
          />
        </template>
      </van-field>

      <keep-alive>
        <van-popup v-model="showLoanTermPicker" round position="bottom">
          <van-picker
            title="商贷年限"
            show-toolbar
            :default-index="
              loanTermList.findIndex((item) => formData.loanTerm === item) || 0
            "
            :columns="loanTermList"
            @confirm="onLoanTermComplete"
            @cancel="showLoanTermPicker = false"
        /></van-popup>
      </keep-alive>

      <!-- 利率方式 -->
      <van-field
        readonly
        clickable
        v-model="formData.interestRateMethod"
        label="利率方式"
        placeholder="点击选择利率方式"
        @focus="showInterestRatePicker = true"
        @click-right-icon="showInterestRatePicker = true"
      >
        <template #right-icon>
          <img
            src="https://static-official.5i5j.com/offical/cdn/f92d18faa3f0d02eec919e78f354c308_1732253601301.png"
            alt=""
            width="15"
            height="15"
          />
        </template>
      </van-field>
      <keep-alive>
        <NewPicker
          title="利率方式"
          :pickList="interestRateMethodList"
          typeKey="interestRate"
          v-if="showInterestRatePicker"
          @pickerHandle="pickerHandle"
          @pickerClose="pickerClose"
        ></NewPicker>
      </keep-alive>

      <!-- 贷款利率 -->
      <van-field
        v-if="formData.interestRateMethod != '按LPR'"
        readonly
        clickable
        v-model="formData.rate"
        label="商贷利率"
        placeholder="点击选择利率方式"
        @focus="rateShow"
        @click-left-icon="handleRateHelp"
        @click-right-icon="showRatePicker = true"
      >
        <template #left-icon>
          <img
            src="../../assets/image/help.png"
            alt=""
            width="15"
            height="15"
          />
        </template>
        <template #right-icon>
          <span v-if="spanShow" class="suffix"> % </span>
          <img
            src="https://static-official.5i5j.com/offical/cdn/f92d18faa3f0d02eec919e78f354c308_1732253601301.png"
            alt=""
            width="15"
            height="15"
          />
        </template>
      </van-field>
      <div class="LprDiv" v-if="formData.interestRateMethod == '按LPR'">
        <span class="LprText">
          {{
            `LPR: 一年期${this.com_rate["1"][0].value}%，五年期${this.com_rate_1["1"][0].value}%`
          }}</span
        >
      </div>

      <van-field
        v-if="formData.interestRateMethod === '按LPR'"
        v-model="formData.customRate"
        type="number"
        name="商贷利率"
        label="商贷利率"
        autocomplete="off"
        placeholder="请输入商贷利率"
        @focus="rateFocus"
        @click-left-icon="handleRateHelp"
        @click-right-icon="rateFocus"
      >
        <template #left-icon>
          <img
            src="../../assets/image/help.png"
            alt=""
            width="15"
            height="15"
          />
        </template>
        <template #input>
          <div @click="rateFocus" class="input-container">
            <span>{{ formData.customRate }}</span>
            <div
              :style="rateKeyboardShow ? 'opacity:1' : 'opacity:0'"
              class="cursor"
            ></div>
          </div>
        </template>
        <template #right-icon>
          <span class="suffix">%</span>
        </template>
      </van-field>

      <!-- 贷款利率-数字键盘 -->
      <van-number-keyboard
        :show="rateKeyboardShow"
        v-model="formData.customRate"
        theme="custom"
        extra-key="."
        close-button-text="完成"
        @close="rateKeyboardClose"
        @blur="rateKeyboardClose"
        style="z-index: 3000"
      />

      <keep-alive>
        <NewPicker
          :title="
            formData.interestRateMethod === '按LPR' ? '本月LPR' : '旧版基准利率'
          "
          :pickList="
            formData.interestRateMethod === '按LPR' ? rateList : rateBaseList
          "
          typeKey="rate"
          v-if="showRatePicker"
          @pickerHandle="pickerHandle"
          @pickerClose="pickerClose"
          @clickPicker="handleCustomRate"
        >
          <template #footer>
            <div class="picker-footer">
              <span>自定义输入</span>
              <input
                type="text"
                placeholder="请输入贷款利率"
                v-model="formData.customRate"
              />%
              <!-- <button class="customer-btn" @click="handleCustomRate">
                确定
              </button> -->
            </div>
          </template>
        </NewPicker>
      </keep-alive>

      <div style="margin-top: 14px; margin-left: 22px">
        <van-button class="submit-btn" @click="onSubmit">开始计算</van-button>
      </div>

      <div
        v-if="placeDiv || rateKeyboardShow || customRatekeyboardShow"
        class="placeDiv"
      ></div>
    </van-form>

    <!-- 模态框 -->
    <van-dialog
      v-model="customModalShow"
      show-cancel-button
      confirm-button-color="#FFCC33"
      @confirm="modalConfirm"
      @cancel="modalCancel"
    >
      <template #default>
        <div class="custom-dialog-content">
          目前贷款年限最大{{
            $store.state.location.cityId == 1 ? 25 : 30
          }}年，您确定查看吗？
        </div>
      </template>
    </van-dialog>

    <!-- 提交提示loading-->
    <Loading v-if="isLoading"></Loading>
  </div>
</template>

<script>
import $http from "../../utils/request";
import { mapState } from "vuex";
import { totalNumValidate, CustomDownPaymentNum } from "../../validate/index";
// import Picker from "../../components/Picker";
import NewPicker from "../../components/NewPicker";
import Loading from "../../components/loading";
import { getWebViewEnv } from "../../utils/app-bridge";
export default {
  components: {
    NewPicker,
    // Picker,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      showMehodsPicker: false,
      methodsList: [
        { text: "按房屋总价", value: 1 },
        { text: "按贷款总额", value: 2 },
      ],
      showLoanTermPicker: false,
      // loanTermList: ["5年", "10年", "15年", "20年", "25年", "30年"],
      showAccLoanTermPicker: false,

      showInterestRatePicker: false,
      interestRateMethodList: ["按LPR", "旧版基准利率"],
      showRatePicker: false,
      spanShow: false, // 贷款利率 %显示隐藏
      spanShows: false, // 公积金利率 %显示隐藏
      showAccRatePicker: false,
      showDownPaymentPicker: false,
      placeDiv: false,
      downPaymentList: [
        "20%",
        "25%",
        "30%",
        "35%",
        "40%",
        "45%",
        "50%",
        "60%",
        "70%",
        "80%",
      ],
      formData: {
        total: "0",
        acctotal: "0",
        calcuMethod: this.$route.query.cal || "按贷款总额",
        loanTerm: "",
        accLoanTerm: "",
        customTerm: "",
        customAccTerm: "",
        interestRateMethod: "按LPR",
        rate: "",
        accrate: "",
        customRate: "",
        accCustomRate: "",
        houseTotal: "0",
        isFirst: "1",
        methodType: "2",
        downPayment: this.$store.state.first_downpayment_percent,
        customDownPayment: "",
        businessLoan: "0",
      },
      customModalShow: false,
      selectedPayment: false,
      currentModal: "",
      totalkeyboardShow: false,
      acctotalKeyboardShow: false,
      businessLoanKeyboardShow: false,
      rateKeyboardShow: false,
      houseKeyboardShow: false,
      customDownPaymentKeyboardShow: false,
      customAccTermKeyboardShow: false,
      accCustomRateKeyboardShow: false,
      customTermkeyboardShow: false,
      customRatekeyboardShow: false,

      shoufuKeyboardShow: false,
    };
  },
  watch: {
    loanTermList: {
      handler(newVal) {
        if (newVal) {
          this.formData.loanTerm = newVal[newVal.length - 1];
        }
      },
      immediate: true,
    },
    fundLoanTermList: {
      handler(newVal) {
        if (newVal) {
          this.formData.accLoanTerm = newVal[newVal.length - 1];
        }
      },
      immediate: true,
    },
    rateList: {
      handler(newVal) {
        if (newVal && this.formData.interestRateMethod === "按LPR") {
          this.formData.rate = newVal[0].value;
          this.formData.customRate = newVal[0].value;
        }
      },
      immediate: true,
    },
    rateBaseList: {
      handler(newVal) {
        if (newVal && this.formData.interestRateMethod === "旧版基准利率") {
          this.formData.rate = newVal[0].text;
        }
      },
      immediate: true,
    },
    accRateList: {
      handler(newVal) {
        if (newVal && Array.isArray(newVal)) {
          this.formData.accrate = newVal[0].text;
        }
      },
      immediate: true,
    },
    downPayment: {
      handler(newVal) {
        this.formData.downPayment = newVal;
      },
    },
  },
  methods: {
    pickerClose(typeKey) {
      switch (typeKey) {
        case "downPayment":
          this.showDownPaymentPicker = false;
          break;
        case "accloanTerm":
          this.showAccLoanTermPicker = false;
          break;
        case "accRate":
          this.showAccRatePicker = false;
          break;
        case "loanTerm":
          this.showLoanTermPicker = false;
          break;
        case "interestRate":
          this.showInterestRatePicker = false;
          break;
        case "rate":
          this.showRatePicker = false;
          break;
      }
    },
    pickerHandle(isShow, selected, typeKey) {
      console.log(isShow, selected, typeKey);
      switch (typeKey) {
        case "downPayment":
          this.onDownPaymentComplete(selected);
          break;
        case "accloanTerm":
          this.onAccLoanTermCancel(selected);
          break;
        case "accRate":
          this.onAccRateComplete(selected);
          break;
        case "loanTerm":
          this.onLoanTermComplete(selected);
          break;
        case "interestRate":
          this.onInterestRateComplete(selected);
          if (this.formData.interestRateMethod === "旧版基准利率") {
            this.formData.customRate = "";
          }
          if (this.formData.interestRateMethod === "按LPR") {
            this.formData.customRate = this.rateList[0].value;
          }
          break;
        case "rate":
          this.onRateCancel(selected);
          break;
      }
    },
    //输入=====贷款利率
    rateFocus() {
      this.placeDiv = true;
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 50);
      this.rateKeyboardShow = true;
    },

    rateKeyboardClose() {
      const valueStr = String(parseInt(this.formData.customRate));
      const dicStr = String(this.formData.customRate).split(".")[1];
      if (Number(this.formData.customRate) > 0) {
        if (dicStr?.length > 4) {
          this.$toast("最多输入4位小数");
          this.formData.customRate =
            String(this.formData.customRate).split(".")[0] +
            "." +
            dicStr.substring(0, 4);
        } else if (valueStr.length > 3 || Number(valueStr) > 100) {
          this.$toast("输入数值过大，请重新输入");
          this.formData.customRate = this.rateList[0].value;
        }
      } else {
        this.formData.customRate = this.rateList[0].value;
        this.$toast("请输入大于0的数值");
      }
      this.formData.rate = this.formData.customRate;
      this.rateKeyboardShow = false;
      this.placeDiv = false;
    },
    // 商业贷款总额
    businessLoanFocus() {
      if (this.formData.businessLoan == 0) {
        this.formData.businessLoan = "";
      }
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight);
      }, 50);
      document.activeElement.blur();
    },
    // 数字键盘的关闭
    totalKeyboardClose(bool) {
      this.totalInput(this.formData.total, bool);
      this.totalkeyboardShow = false;
    },
    acctotalKeyboardClose() {
      this.acctotalInput(this.formData.acctotal);
      this.acctotalKeyboardShow = false;
    },
    acctotalShow() {
      this.acctotalKeyboardShow = true;
      this.formData.acctotal = "";
    },
    businessLoanKeyboardClose() {
      this.inputBusinessLoan(this.formData.businessLoan);
      this.businessLoanKeyboardShow = false;
    },
    houseKeyboardClose() {
      if (this.formData.houseTotal) {
        this.onHouseTotal(this.formData.houseTotal);
      }
      this.houseKeyboardShow = false;
    },
    houseTotalShow() {
      if (this.formData.houseTotal == 0) {
        this.formData.houseTotal = "";
      }
      this.houseKeyboardShow = true;
    },
    // 首付比例的数字键盘关闭
    shoufuKeyboardClose() {
      if (this.formData.downPayment) {
        this.onDownPayment(this.formData.downPayment);
      }
      this.shoufuKeyboardShow = false;
    },
    totalShow() {
      this.totalkeyboardShow = true;
      this.formData.total = "";
    },
    onDownPayment(value) {
      // 首付比例输入监听

      if (Number(value)) {
        const valueStr = String(parseInt(value));
        const dicStr = String(value).split(".")[1];

        if (dicStr) {
          this.$toast("请输入整数");
          this.formData.downPayment = valueStr;
        } else if (Number(valueStr) > 100) {
          this.$toast("输入值过大,请重新输入");
          this.formData.downPayment =
            this.$store.state.first_downpayment_percent;
        } else {
          this.formData.downPayment = value;
        }
        this.formData.total =
          (Number(this.formData.houseTotal) *
            (100 - parseInt(this.formData.downPayment))) /
          (100).toFixed(2);
      }
    },
    rateShow() {
      this.showRatePicker = true;
      setTimeout(() => {
        window.scrollTo(0, document.body.scrollHeight + 50);
      }, 50);
    },
    onSubmit() {
      // 开始计算的埋点

      // TODO 表单提交
      if (this.formData.calcuMethod === "按贷款总额") {
        if (!Number(this.formData.total)) {
          this.$toast("请输入大于0金额");
          return;
        } else if (!Number(this.formData.acctotal)) {
          this.$toast("请输入大于0的数值");
          return;
        } else if (!Number(this.formData.businessLoan)) {
          this.$toast("请输入大于0金额");
          return;
        }
      } else if (this.formData.calcuMethod === "按房屋总价") {
        if (!Number(this.formData.houseTotal)) {
          this.$toast("房屋总价不能为空");
          return;
        } else if (!Number(this.formData.total)) {
          this.$toast("请输入大于0金额");
          return;
        } else if (!Number(this.formData.acctotal)) {
          this.$toast("请输入大于0的数值");
          return;
        } else if (!Number(this.formData.businessLoan)) {
          this.$toast("请输入大于0金额");
          return;
        }
      }

      let data = {};
      data.com_loan_time = parseInt(this.formData.loanTerm); // 商业贷款年限
      data.com_loan_value = Number(this.formData.businessLoan); // 商业贷款金额
      // 判断当前是不是自定义贷款利率，逻辑同商业贷款利率

      if (this.formData.customRate) {
        if (this.formData.interestRateMethod === "按LPR") {
          if (this.isLprCustom()) {
            data.com_loan_rate = Number(this.formData.customRate) / 100;
          } else {
            return;
          }
        } else {
          data.com_loan_rate =
            Number(
              this.rateBaseList.find((item) => item.text === this.formData.rate)
                ?.value
            ) / 100 || Number(this.formData.rate) / 100; // 商贷利率
        }
      } else {
        if (this.formData.interestRateMethod === "按LPR") {
          if (this.isLprCustom()) {
            data.com_loan_rate = Number(this.formData.rate) / 100;
          } else {
            return;
          }
          // data.com_loan_rate = Number(this.rateList.find(item => item.text === this.formData.rate).value) / 100; // 商业贷款利率
        } else {
          data.com_loan_rate =
            Number(
              this.rateBaseList.find((item) => item.text === this.formData.rate)
                ?.value
            ) / 100; // 商业贷款利率
        }
      }

      data.fund_loan_time = parseInt(this.formData.accLoanTerm); // 公积金贷款年限
      data.fund_loan_value = Number(this.formData.acctotal); // 公积金贷款金额
      // 判断当前是不是自定义公积金利率，逻辑同公积金利率

      // data.fund_loan_rate = Number(this.formData.accrate) / 100;

      data.fund_loan_rate =
        Number(
          this.accRateList.find((item) => item.text === this.formData.accrate)
            ?.value
        ) / 100 || Number(this.formData.accrate) / 100; // 公积金贷款利率

      if (this.formData.calcuMethod === "按房屋总价") {
        data.house_price = Number(this.formData.houseTotal); // 房屋总价 默认0
      } else {
        data.is_first = "";
        data.house_price = "";
        data.payment_percent = "";
      }

      // 如果有经纪人信息给经纪人推送
      if (this.peopleInfo.broker_id) {
        const { broker_id, user_id } = this.peopleInfo;
        data.user_id = user_id;
        data.broker_id = broker_id;
        data.result_url = `${
          window.location.origin
        }/calculator/#/CommercialIoanDetailed?type=composition&cal=${
          this.formData.calcuMethod
        }&form=${encodeURIComponent(JSON.stringify(data))}&cityid=${
          this.$store.state.location.cityId
        }&cityname=${this.$store.state.location.cityName}&hideBroker=${
          this.$route.query?.hideBroker
        }`;
      }
      this.isLoading = true;
      data.platform = getWebViewEnv();
      $http({
        url: `/appapi/normals/${this.$store.state.location.cityId}/v1/loandetails`,
        method: "post",
        data,
      })
        .then((res) => {
          if (res.msg == "OK") {
            this.$store.dispatch("setCalcuRes", res.data);
            this.isLoading = false;
            // 在localStorage中做本地持久化
            localStorage.setItem("calcuRes", JSON.stringify(res.data));
            this.$router.push(
              `/CommercialIoanDetailed?type=composition&cal=${this.formData.calcuMethod}&cityid=${this.$store.state.location.cityId}&cityname=${this.$store.state.location.cityName}&hideBroker=${this.$route.query?.hideBroker}`
            );
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("err--->", err);
        });
    },
    isLprCustom() {
      // this.formData.rate
      const LPRreg = /(^[0-9]{1,2}$)|(^[0-9]{1,2}[\.]{1}[0-9]{1,5}$)/;
      const isLPRExit =
        LPRreg.test(this.formData.customRate) &&
        Number(this.formData.customRate) > 0;

      if (this.formData.customRate == 0 || this.formData.customRate == "") {
        // this.$toast("请输入大于0的数字");
        this.$toast("请将商贷利率修改为大于0，小于100的数字，支持小数点后五位");
        return false;
      }
      if (!/^\d+(\.\d{1,5})?$/.test(this.formData.customRate)) {
        // this.$toast("最多支持小数点后5位");
        this.$toast("请将商贷利率修改为大于0，小于100的数字，支持小数点后五位");
        return false;
      }
      if (!isLPRExit) {
        // this.$toast("请输入小于100的数字");
        this.$toast("请将商贷利率修改为大于0，小于100的数字，支持小数点后五位");
        return false;
      }
      return true;
    },
    // 贷款总额的输入
    totalInput(value, bool) {
      this.formData.total = totalNumValidate(value, this, bool);
      this.formData.businessLoan = Number(this.formData.total)
        ? String(Number(this.formData.total))
        : "";
    },
    // 公积金总额的输入
    acctotalInput(value) {
      if (!Number(this.formData.total)) {
        this.$toast(`贷款总额为0，请输入贷款总额。`);
        this.formData.acctotal = "0";
        return;
      }

      if (Number(this.formData.total) && Number(value)) {
        // 此处需要判断计算方式
        if (this.formData.calcuMethod === "按贷款总额") {
          if (Number(value) > this.firstMaxFundLoan) {
            this.formData.businessLoan = String(
              Number(this.formData.total) - this.firstMaxFundLoan
            );
            this.formData.acctotal = String(this.firstMaxFundLoan);
            this.$toast(
              `当前公积金上限为${this.firstMaxFundLoan}万，请重新输入`
            );
          } else {
            this.formData.businessLoan = String(
              Number(this.formData.total) - Number(value)
            );
          }
        } else {
          // 定义一个公积金最大额度
          let MaxFundLoan = 0;
          // 按房屋总价 需要判断当前是首套还是二套
          if (this.formData.isFirst === "1") {
            // 当前为首套
            MaxFundLoan = this.firstMaxFundLoan;
          } else {
            // 当前为二套
            MaxFundLoan = this.secondMaxFundLoan;
          }
          // 获得公积金最大额度之后，执行和按贷款总额相同的逻辑
          if (Number(value) > MaxFundLoan) {
            this.formData.businessLoan = String(
              Number(this.formData.total) - MaxFundLoan
            );
            this.formData.acctotal = String(MaxFundLoan);
            this.$toast(`当前公积金上限为${MaxFundLoan}万，请重新输入`);
          } else {
            this.formData.businessLoan = String(
              Number(this.formData.total) - Number(value)
            );
          }
        }

        // 公积金的总额大于贷款总额的情况
        if (Number(value) > Number(this.formData.total)) {
          this.formData.businessLoan = "0";
          this.formData.acctotal = this.formData.total;
        }
      }
    },
    // 商业贷款输入
    inputBusinessLoan(value) {
      if (!Number(this.formData.total)) {
        this.$toast(`贷款总额为0，请输入贷款总额。`);
        this.formData.businessLoan = "0";
        return;
      }

      this.formData.businessLoan = totalNumValidate(value, this);

      // if (Number(this.formData.total) && Number(this.formData.businessLoan)) {
      //   console.log(
      //     "商贷金额",
      //     Number(this.formData.total) && Number(this.formData.businessLoan)
      //   );
      //   if (Number(this.formData.businessLoan) > Number(this.formData.total)) {
      //     console.log(
      //       "商贷金额大于贷款总额",
      //       Number(this.formData.businessLoan) > Number(this.formData.total)
      //     );
      //     // 当前输入数字自动修正为贷款总额减另外一个金额。当公积金金额输入超过最大范围，则自动变为最大值，同时商贷金额按上述规则调整。
      //     this.$toast("已超过贷款总额");
      //     this.formData.businessLoan =
      //       Number(this.formData.total) - Number(this.formData.acctotal);
      //   } else {
      //     console.log(
      //       "商贷金额小于贷款总额",
      //       Number(this.formData.businessLoan) <= Number(this.formData.total)
      //     );
      //     // 计算贷款总额与商业贷款
      //     const accDVal = String(Number(this.formData.total) - Number(value));
      //     // 判断差值与当前城市的公积金贷款上限，公积金的上限的取值，需要依据计算方式做区分
      //     //  公积金上限取当前城市上限

      //     if (accDVal > this.firstMaxFundLoan) {
      //       this.$toast(
      //         `当前公积金上限为${this.firstMaxFundLoan}万，请重新输入`
      //       );
      //       this.formData.acctotal = String(this.firstMaxFundLoan);
      //     } else {
      //       this.formData.acctotal = String(accDVal);
      //     }
      //     // this.formData.acctotal =
      //     //   accDVal > MaxFundLoan ? String(MaxFundLoan) : String(accDVal);
      //   }
      // }
      if (Number(this.formData.total) && Number(this.formData.businessLoan)) {
        const count =
          Number(this.formData.businessLoan) + Number(this.formData.acctotal);
        if (count > Number(this.formData.total)) {
          this.$toast("已超过贷款总额");
          this.formData.businessLoan = String(
            Number(this.formData.total) - Number(this.formData.acctotal)
          );
        } else {
          const accDVal = String(Number(this.formData.total) - Number(value));
          if (Number(accDVal) > this.firstMaxFundLoan) {
            this.$toast(
              `当前公积金上限为${this.firstMaxFundLoan}万，请重新输入`
            );
            this.formData.acctotal = String(this.firstMaxFundLoan);
            this.formData.businessLoan = String(
              Number(this.formData.total) - Number(this.firstMaxFundLoan)
            );
          } else {
            this.formData.acctotal = String(
              Number(this.formData.total) - Number(value)
            );
          }
        }
      }
    },

    onLoanTermComplete(value) {
      this.formData.loanTerm = value;
      if (this.formData.interestRateMethod === "按LPR") {
        if (parseInt(this.formData.loanTerm) > 1) {
          this.formData.rate = this.com_rate_1["1"][0].text;
        } else {
          this.formData.rate = this.com_rate["1"][0].text;
        }
      }
      this.showLoanTermPicker = false;
    },
    onAccLoanTermCancel(value) {
      this.formData.accLoanTerm = value;
      if (parseInt(this.formData.accLoanTerm) > 5) {
        this.formData.accrate = this.fund_rate_5[0].text;
      } else {
        this.formData.accrate = this.fund_rate[0].text;
      }
      this.showAccLoanTermPicker = false;
    },
    onInterestRateComplete(value) {
      this.formData.interestRateMethod = value;
      if (this.formData.interestRateMethod === "按LPR") {
        this.formData.rate = this.rateList[0].text;
      } else {
        this.formData.rate = this.rateBaseList[0].text;
      }
      this.showInterestRatePicker = false;
    },
    modalConfirm() {
      // TODO 模态框确定
      this.customModalShow = false;
      if (this.currentModal === "acc") {
        this.formData.accLoanTerm = `${this.formData.customAccTerm}年`;
        if (parseInt(this.formData.accLoanTerm) > 5) {
          this.formData.accrate = this.fund_rate_5[0].text;
        } else {
          this.formData.accrate = this.fund_rate[0].text;
        }
        this.showAccLoanTermPicker = false;
      } else if (this.currentModal === "busy") {
        this.formData.loanTerm = `${this.formData.customTerm}年`;
        // 按照商业贷款的利率方式设置贷款利率的默认值
        if (this.formData.interestRateMethod === "按LPR") {
          if (parseInt(this.formData.loanTerm) > 1) {
            this.formData.rate = this.com_rate_1["1"][0].text;
          } else {
            this.formData.rate = this.com_rate["1"][0].text;
          }
        }
        this.showLoanTermPicker = false;
      }
    },
    modalCancel() {
      // TODO 模态框取消
      this.formData.customTerm = "";
    },
    onRateCancel(item) {
      this.formData.rate = item.text;
      this.showRatePicker = false;
    },
    onAccRateComplete(item) {
      this.formData.accrate = item.text;
      this.showAccRatePicker = false;
    },
    accRateChange(picker, value, index) {
      this.formData.accrate = value.text;
    },
    handleRateHelp() {
      this.$store.commit("showRateModal", true);
    },
    handleownPayment() {
      this.$store.commit("showHouseModal", true);
    },
    handleCustomRate() {
      const valueStr = String(parseInt(this.formData.customRate));
      const dicStr = String(this.formData.customRate).split(".")[1];
      if (Number(this.formData.customRate) > 0) {
        if (dicStr?.length > 4) {
          this.$toast("最多输入四位小数");
          this.formData.customRate =
            String(this.formData.customRate).split(".")[0] +
            "." +
            dicStr.substring(0, 4);
          this.formData.rate = this.formData.customRate;
        } else if (valueStr.length > 3 || Number(valueStr) > 100) {
          this.$toast("输入值过大,请重新输入");
          this.formData.customRate = this.rateBaseList[0].value;
        } else {
          this.formData.rate = this.formData.customRate;
          this.showRatePicker = false;
          this.customRatekeyboardShow = false;
          this.spanShow = true;
        }
      } else {
        this.formData.customRate = this.rateBaseList[0].value;
        this.$toast("请输入大于0的数值");
      }
    },
    handleAccCustomRate() {
      const valueStr = String(parseInt(this.formData.accCustomRate));
      const dicStr = String(this.formData.accCustomRate).split(".")[1];

      if (Number(this.formData.accCustomRate) > 0) {
        if (dicStr?.length > 4) {
          this.$toast("最多输入四位小数");
          this.formData.accrate =
            String(this.formData.accCustomRate).split(".")[0] +
            "." +
            dicStr.substring(0, 4);
          this.formData.accCustomRate =
            String(this.formData.accCustomRate).split(".")[0] +
            "." +
            dicStr.substring(0, 4);
          this.showAccRatePicker = false;
          this.spanShows = true;
        } else if (valueStr.length > 3 || Number(valueStr) > 100) {
          this.$toast("输入值过大,请重新输入");
          this.formData.accCustomRate = "";
        } else {
          this.formData.accrate = this.formData.accCustomRate;
          this.showAccRatePicker = false;
          this.spanShows = true;
        }
      } else {
        this.formData.accCustomRate = "";
        this.$toast("请输入大于0的数值");
      }
      // const LPRreg = /^(\d{1,2})(\.{accrate0}|\.\d{2})$/;
      // const LPRreg = /(^[0-9]{1,2}$)|(^[0-9]{1,2}[\.]{1}[0-9]{1,5}$)/;
      // const isLPRExit =
      //   LPRreg.test(this.formData.accCustomRate) &&
      //   Number(this.formData.accCustomRate) > 0;

      // if (this.formData.accCustomRate) {
      //   if (isLPRExit) {
      //     // 通过验证
      //     this.formData.accrate = this.formData.accCustomRate;
      //     this.showAccRatePicker = false;
      //     this.spanShows = true;
      //   } else {
      //     this.$toast("请输入数字1-99，支持小数点后5位。");
      //   }
      // } else {
      //   this.$toast("自定义贷款利率不能为空");
      // }
    },
    onDownPaymentComplete(value) {
      // 首付比例
      this.formData.downPayment = value;
      this.selectedPayment = true;
      // 计算首付
      this.formData.businessLoan = this.formData.total = String(
        (
          (Number(this.formData.houseTotal) *
            (100 - parseInt(this.formData.downPayment))) /
          100
        ).toFixed(2)
      );
      this.showDownPaymentPicker = false;
    },
    handleCustomDownPayment() {
      // 自定义首付比例
      if (Number(this.formData.customDownPayment)) {
        if (
          Number(this.formData.customDownPayment) > 100 ||
          Number(this.formData.customDownPayment) < 10
        ) {
          this.$toast("请输入10-100之间的数字");
        } else {
          this.formData.customDownPayment = CustomDownPaymentNum(
            this.formData.customDownPayment
          );
          //
          this.formData.downPayment = `${this.formData.customDownPayment}%`;
          this.selectedPayment = true;

          this.formData.businessLoan = this.formData.total = String(
            (
              (Number(this.formData.houseTotal) *
                (100 - parseInt(this.formData.downPayment))) /
              100
            ).toFixed(2)
          );

          this.showDownPaymentPicker = false;
        }
      } else {
        this.$toast("自定义首付比例不能为空！");
      }
    },
    onHouseTotal(value) {
      let defaultPercent = "";
      // 房屋总价的输入监听
      if (Number(value)) {
        const valueStr = String(parseInt(value));
        const dicStr = String(value).split(".")[1]
          ? String(value).split(".")[1]
          : "00";
        if (valueStr.length > 5 || Number(value) > 99999) {
          this.$toast("输入值过大,请重新输入");
          this.formData.houseTotal = 0;
        } else {
          if (dicStr.length > 2) {
            this.$toast("最多输入2位小数");
            this.formData.houseTotal =
              String(value).split(".")[0] + "." + dicStr.substr(0, 2);
          }
        }

        defaultPercent = this.formData.downPayment;
        this.formData.total =
          (Number(this.formData.houseTotal) *
            (100 - parseInt(defaultPercent))) /
          100;
        this.formData.total = Number(this.formData.total).toFixed(2);

        this.formData.businessLoan = this.formData.total;
      } else {
        this.$toast("请输入大于0的数值");
        this.formData.total = 0;
      }
    },
    calcuMethodChange(name) {
      if (name === "1") {
        this.formData.calcuMethod = "按房屋总价";
      } else if (name === "2") {
        this.formData.calcuMethod = "按贷款总额";
      }
    },
    isFirstChange(name) {
      // 用户选择首套或者二套时，请求后台的首付比例
      this.selectedPayment = false;
      if (name === "1") {
        this.formData.total = this.formData.businessLoan = String(
          (
            (Number(this.formData.houseTotal) *
              (100 - parseInt(this.firstDefault))) /
            100
          ).toFixed(2)
        );
      } else if (name === "2") {
        this.formData.total = this.formData.businessLoan = String(
          (
            (Number(this.formData.houseTotal) *
              (100 - parseInt(this.secondDefault))) /
            100
          ).toFixed(2)
        );
      }
    },
  },
  computed: {
    downPayment() {
      return this.$store.state.first_downpayment_percent;
    },
    defaultCal() {
      if (this.$route.query.cal) {
        if (this.$route.query.cal === "按贷款总额") {
          return 1;
        } else if (this.$route.query.cal === "按房屋总价") {
          return 0;
        }
      } else {
        return 1;
      }
    },
    peopleInfo() {
      return this.$store.state.people;
    },
    firstDefault() {
      return this.$store.state.downPayment.firstDefault;
    },
    secondDefault() {
      return this.$store.state.downPayment.secondDefault;
    },
    locationCity() {
      return this.$store.state.location.cityName;
    },
    firstMaxFundLoan() {
      return this.$store.state.firstMaxFundLoan;
    },
    secondMaxFundLoan() {
      return this.$store.state.secondMaxFundLoan;
    },
    ...mapState({
      com_rate: (state) => {
        return state.com_rate;
      },
      com_rate_1: (state) => state.com_rate_1,
      fund_rate: (state) => {
        return state.fund_rate;
      },
      fund_rate_5: (state) => state.fund_rate_5,
    }),
    rateList() {
      // 商业贷款的贷款利率
      return parseInt(this.formData.loanTerm) > 1
        ? this.com_rate_1["1"]
        : this.com_rate["1"];
    },
    rateBaseList() {
      return parseInt(this.formData.loanTerm) > 1
        ? this.com_rate_1["2"]
        : this.com_rate["2"];
    },
    accRateList() {
      // 公积金贷款利率
      return parseInt(this.formData.accLoanTerm) > 5
        ? this.fund_rate_5
        : this.fund_rate;
    },
    loanTermList() {
      return this.$store.state.loanTime;
    },
    fundLoanTermList() {
      return this.$store.state.fundLoanTime;
    },
  },
};
</script>
<style scoped>
.calcu-body {
  width: 714px;
  margin: 24px auto;
  border-radius: 16px;
  overflow: hidden;
}
.form-bg {
  background-color: #ffffff;
  padding-bottom: 25px;
}
.submit-btn {
  width: 638px;
  height: 96px;
  border-radius: 16px;
  line-height: 96px;
  background-color: #ffcc33;
  border: none;
  font-size: 28px;
  color: #333333;
  font-weight: 600;
}
.placeDiv {
  height: 300px;
  width: 100%;
}
.LprDiv {
  width: 666px;
  height: 72px;
  background: #fff9e5;
  border-radius: 12px;
  margin-top: 24px;
  margin-left: 24px;
  display: flex;
  align-items: center;
}
.LprText {
  display: block;
  margin-left: 32px;
  font-weight: 400;
  font-size: 28px;
  color: #222222;
  line-height: 40px;
}
.calcu-body /deep/ .van-cell {
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 48px;
  height: 129px;
  box-sizing: border-box;
}

.calcu-body /deep/ .van-field__left-icon {
  position: absolute;
  top: 64px;
  left: 145px;
}
.calcu-body /deep/ .van-cell__title {
  color: #292b33;
  font-weight: bold;
  font-size: 32px;
}
.calcu-body /deep/ .van-field__body input,
.suffix {
  font-size: 28px;
  color: #333;
}
.input-container {
  width: 100%;
  display: flex;
  align-items: center;
}
.calcu-body .cursor {
  margin-left: 2px;
  height: 30px;
  width: 1px;
  opacity: 0;
  background: url("https://static-official.5i5j.com/offical/cdn/5e00398904093f6aca4be6a71ba652e1_1720433382281.gif")
    no-repeat center center;
}
.radioDiv {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.calcu-body /deep/ .van-radio--horizontal {
  margin-right: 12px;
}
.radioDiv .active {
  width: 225px;
  height: 76px;
  background: url("https://static-official.5i5j.com/offical/cdn/8d4520f04014bfa00ce00e775c946ad8_1731550918382.png")
    no-repeat;
  background-size: 225px 76px;
  font-weight: 600;
  color: #222222;
}
.radioDiv .inactive {
  background: url("https://static-official.5i5j.com/offical/cdn/1180cf092a9e7e1b81b02ffdffefa6ff_1731563918501.png")
    no-repeat;
  background-size: 225px 76px;
  font-weight: 400;
  color: #666666;
}
.radio-text {
  width: 225px;
  height: 76px;
  font-size: 28px;
  text-align: center;
  line-height: 76px;
  font-style: normal;
}
.rateInput {
  position: relative;
}
.cal-method /deep/ .van-radio__label {
  margin-left: 0;
}
.van-cell:after {
  border-bottom: 0px !important;
}
.calcu-body /deep/ .van-cell:not(:first-child) .van-field__value {
  background-color: #f9f9f9 !important;
  width: 482px;
  height: 76px;
  border: 2px solid #eeeeee;
  border-radius: 12px;
  font-weight: 600;
  font-size: 28px;
  color: #222222;
  line-height: 76px;
  padding-left: 32px;
  padding-right: 32px;
}

.calcu-body /deep/ .van-field__label {
  height: 76px;
  width: 144px;
  font-weight: 500;
  font-size: 28px;
  color: #222222;
  line-height: 76px;
  margin-right: 62px;
}
.calcu-body /deep/ .van-radio-group .van-radio:last-child {
  margin-right: 0;
}
.calcu-body /deep/ .van-radio__icon .van-icon {
  display: none;
}
.popup-title {
  width: 670px;
  height: 112px;
  border-bottom: 2px solid #eeeeee;
  line-height: 112px;
  font-size: 32px;
  color: #333;
  margin: 0 auto;
  text-align: center;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.popup-title .complete {
  color: #ffcc33;
}
.custom-term {
  height: 112px;
  width: 670px;
  margin: 0 auto;
  border-top: 2px solid #eeeeee;
}
.customer-btn {
  color: #333;
  border: none;
  outline: none;
}
.custom-dialog-content {
  text-align: center;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 0 25px 48px 25px;
  padding-top: 80px;
  width: 568px;
  height: 218px;
  font-size: 30px;
  font-weight: 500;
  color: #333333;
  line-height: 45px;
  letter-spacing: 1px;
}
.down-payment-per {
  display: inline-block;
}
.margin-b-244 {
  margin-bottom: 488px;
}
</style>
